import axios from "axios";
import router from "@/router";
import { Message } from 'element-ui'
import routes from "@/config/routes";
import { getToken } from "@/utils/auth";
import Sentry from './sentry' // 引入Sentry配置

const publicURLs = []
const base = process.env.VUE_APP_API_ROOT;
axios.defaults.timeout = 180000; // 全局设置超时时间为180000ms  1000 *  60 * 3
//如果是 税务师 的api ${base}/plat/ 全部替换成 ${base}/firm/



const hostWithPort = window.location.host;

function getSentryRequest(response, requestParams) {
  const xhr = response && response.request && response.request.__sentry_xhr__
    ? response.request.__sentry_xhr__
    : {};
  const config = response && response.config ? response.config : {};

  return {
    body: xhr.body || config.data || requestParams,
    method: xhr.method || (config.method ? config.method.toUpperCase() : undefined),
    status_code: xhr.status_code || (response && response.status),
    url: xhr.url || config.url,
    request_params: config.params || requestParams,
    request_headers: config.headers,
    response_headers: response && response.headers,
    route_name: router.app && router.app.$route && router.app.$route.name,
    page_url: window.location.href
  }
}

function getResponseData(response) {
  return response && response.data !== undefined && response.data !== null
    ? response.data
    : {}
}

function getResponseCode(response) {
  const data = getResponseData(response);
  return data && typeof data === 'object'
    ? data.code
    : undefined
}

function getApiErrorReason(response, fallbackMessage) {
  const data = getResponseData(response);
  if (typeof data !== 'object') {
    return data || fallbackMessage
  }
  return data.message ||
    data.msgInfo ||
    data.msg ||
    data.errMsg ||
    data.error ||
    fallbackMessage
}

function getApiErrorMessage(response, fallbackMessage, requestParams) {
  const request = getSentryRequest(response, requestParams);
  const reason = getApiErrorReason(response, fallbackMessage);
  return `api错误: ${request.url || "未知接口"} - ${reason}`
}

function getApiErrorFingerprint(request, response, reason) {
  const url = request.url || '未知接口';
  const urlWithoutQuery = String(url).split('?')[0];

  return [
    'api-error',
    urlWithoutQuery,
    String(getResponseCode(response) || request.status_code || ''),
    String(reason || '')
  ]
}

function captureApiException(message, response, requestParams) {
  const request = getSentryRequest(response, requestParams);
  const reason = getApiErrorReason(response, message);
  const errorMessage = getApiErrorMessage(response, message, requestParams);
  const error = new Error(errorMessage);
  error.name = 'ApiError';
  Sentry.captureException(error, {
    message: errorMessage,
    level: 'info',
    fingerprint: getApiErrorFingerprint(request, response, reason),
    tags: {
      priority: 'low'
    },
    extra: {
      request,
      response: getResponseData(response),
      url: request.url
    }
  })
}

axios.interceptors.request.use(
  config => {
    if (window.location.href.includes("/pdfFrontGenerator/") && router.app.$route.params.from === 'shiwusuo') {
      config.url = config.url.replace(`${base}/plat/`, `${base}/taxfirm/`)
    }
    if (window.location.href.includes("/wordResultFrontGenerator/") && router.app.$route.params.from === 'shiwusuo') {
      config.url = config.url.replace(`${base}/plat/`, `${base}/taxfirm/`)
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

//全局配置请求头+token
axios.interceptors.request.use(
  config => {
    // 判断是否存在token，如果存在的话，则每个http header都加上token
    let token = localStorage.getItem("authorization");
    let shareAuthorization = localStorage.getItem("Share-Authorization");
    let shareAccessToken = localStorage.getItem("share-accessToken");
    let accessToken = localStorage.getItem("accessToken") || '';



    const routerName = router.app.$route.name;
    if (token && config.url.indexOf(base) > -1) {
      let isPublicURLs = publicURLs.some(url => {
        return config.url.startsWith(url)
      });
    }
    if (shareAuthorization) {
      config.headers['Share-Authorization'] = shareAuthorization;
    }
    if (shareAccessToken && shareAccessToken != undefined && shareAccessToken != 'undefined' && routerName == 'oemGuardV4_3' && !config.url.includes('/shuian-home/')) {
      config.headers['share-accessToken'] = shareAccessToken;
    }

    if (config.url.includes('/daqc/') || config.url.includes('/open/')) {
      config.headers['accessToken'] = accessToken;
    } else {
      config.headers['authorization'] = getToken();
    }
    config.timeout = 180000;
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// 响应拦截器
axios.interceptors.response.use(response => {
  if (response.status === 200) {
    const responseCode = getResponseCode(response);
    //token失效
    // if (response.data && response.data.msgCode == "1001") {
    //   router.push({name: "login"});
    //   return Promise.reject(response);
    // } else {
    if (responseCode == 5203) {
      captureApiException('报告丢失', response)
      router.push({
        name: "reportLost",
      });
      return;
    }
    if (responseCode == 5000) {
      Message.warning({ message: getApiErrorReason(response, '接口错误') });
      captureApiException('5000错误', response)
      return;
    }
    if(responseCode != 200){
      captureApiException('非200错误', response)
    }
    // if (response.data.code == 5001) {
    //   Message.warning({ message: response.data.message });
    // }
    return Promise.resolve(response);
    // }
  } else {
    captureApiException('reject错误', response)

    return Promise.reject(response);
  }
});

//不加这个IE会缓存GET请求
axios.defaults.headers.get['Cache-Control'] = 'no-cache'
axios.defaults.headers.get['Pragma'] = 'no-cache'

export default axios;


/**
 * get方法，对应get请求
 * @param {String} url 请求的url地址
 * @param {Object} params 请求时携带的参数
 * @param {String} autoWarning
 * @returns {Promise<unknown>}
 */
export function get(url, params, autoWarning = true) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,

      })
      .then(res => {

        if (autoWarning && getResponseCode(res) != 200) {
          // if(window.innerWidth < 750){
          Message.warning({ message: getApiErrorReason(res, '接口错误') });
          // }
        }
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params, isAutoWaring = true, config) {
  config = { ...config, timeout: 180000 }
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then(res => {
        if (isAutoWaring && getResponseCode(res) != 200) {
          // if(window.innerWidth < 750){
          Message.warning({ message: getApiErrorReason(res, '接口错误') });
          // }
        }
        resolve(res);
      })
      .catch(err => {
        reject(err);
      });
  });
}
